module.exports = __webpack_public_path__ + "img/vod-04.e3fba2a7.jpg";